<template>
  <div class="crushing-instructions">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">KROSSNING</h1>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container v-if="crushingRecord" class="view-container text-center break-word">
      <div class="name-info">
        <b-row>
          <b-col sm="12">
            <h1>
              {{crushingRecord.recordHeading}}
            </h1>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="name-info">
        <b-row>
          <b-col sm="12">
            <div>
              <img
                v-b-tooltip.hover.auto
                title="Beredningsform"
                src="data:image/svg+xml;base64,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" />
              <span>{{ crushingRecord.primaryDrugFormTextSv }}</span>
            </div>
            <div>
              <img
                v-b-tooltip.hover.auto
                title="Exempelläkemedel"
                src="../assets/icons8-blister-pack.svg" alt="Exempelläkemedel icon" />
              <span>{{ exampleDrugs || 'Inga exempelläkemedel' }}</span>
            </div>
          </b-col>
        </b-row>
      </div>
      <hr />

      <div class="detailed-info text-left">
        <b-row>
          <b-col>
            <h4>Kunskapsunderlag vid krossning av läkemedel</h4>
            <a href="javascript:void(0)" v-b-toggle.collapse1 variant="primary">
              Generella anvisningar
              <i class="fa fa-angle-down"></i>
            </a>
            <b-collapse id="collapse1" class="mt-2">
              <editor
                :areaKey="'gi'"
                v-model="generalInstructions"
                emptyLabel="[Generella anvisningar]"
              ></editor>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row v-if="crushingRecord.recommendations.keyPeroral">
          <b-col sm="12">
            <h4>Rekommendation för oral administrering vid sväljsvårigheter</h4>
          </b-col>
          <b-col sm="12">
            <editor
              :areaKey="'pa'"
              v-model="crushingRecord.recommendations.keyPeroral"
              emptyLabel="[Rekommendation för oral administrering vid sväljsvårigheter]"
            ></editor>
          </b-col>
        </b-row>
        <b-row v-if="crushingRecord.recommendations.keyEnteral">
          <b-col sm="12">
            <h4>Rekommendation för administrering i enteral sond</h4>
          </b-col>
          <b-col sm="12">
            <editor
              :areaKey="'es'"
              v-model="crushingRecord.recommendations.keyEnteral"
              emptyLabel="[Rekommendation för administrering i enteral sond]"
            ></editor>
          </b-col>
        </b-row>
        <b-row v-if="crushingRecord.recommendations.keyAlternative">
          <b-col sm="12">
            <h4>Alternativ administreringsväg eller alternativt läkemedel</h4>
          </b-col>
          <b-col sm="12">
            <editor
              :areaKey="'alt'"
              v-model="crushingRecord.recommendations.keyAlternative"
              emptyLabel="[Alternativ administreringsväg]"
            ></editor>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h4>Bedömda produkter</h4>
            <a href="javascript:void(0)" v-b-toggle.collapse2 variant="primary">
              Visa
              <i class="fa fa-angle-down"></i>
            </a>
            <b-collapse id="collapse2" visible class="mt-2">
              <b-row class="row-assessed">
                <b-col>
                  Produktnamn
                </b-col>
                <b-col>
                  Läkemedelsform
                </b-col>
                <b-col>
                  Npl Id
                </b-col>
              </b-row>
              <b-row class="row-assessed" v-for="drug in crushingRecord.assessedDrugList" :key="drug.nplId">
                <b-col>
                  {{ drug.silDrugName }}
                </b-col>
                <b-col>
                  {{ drug.silDrugFormTextSv }}
                </b-col>
                <b-col>
                  {{ drug.nplId }}
                </b-col>
              </b-row>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row v-if="crushingRecord.recordChangeDate">
          <b-col>
            <modified-date :date="crushingRecord.recordChangeDate" />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs, computed } from '@vue/composition-api'
import { map } from 'lodash'
import { clickTracker } from '@/services/helpers'
import axios from 'axios'

export default {
  name: 'ViewCrushingRecord',
  props: ['id'],
  computed: {
    generalInstructions () {
      return this.$store.getters.generalRecText
    }
  },
  setup (props) {
    const state = reactive({
      crushingRecord: null
    })

    onMounted(() => {
      window.scrollTo(0, 0)
      getRecord()
      clickTracker('keyCrushingRecord', {recordId: props.id})
    })

    const exampleDrugs = computed(() => map(state.crushingRecord.exampleDrugList, drug => drug.silDrugName).join(', ') || '')

    async function getRecord () {
      axios.get('crushingapi/getCrushingRecordForDisplay', { params: { recordKey: props.id } })
      .then((result) => {
        if (result.data) {
          state.crushingRecord = result.data
        } else {
          console.log(result.data.message)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }

    return {
      ...toRefs(state),
      exampleDrugs
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1,
h2 {
  font-weight: normal;
}

.name-info {
  padding: .5em 0;
  font-weight: bold;

  .npl-title {
    font-weight: bold;
  }

  .npl-id {
    margin-bottom: 0;
    padding: 0 0.5em;
    white-space: nowrap;
    color: $turkos;
  }

  h1 {
    margin-top: 0;
  }

  .low-margin-bottom {
    margin-bottom: 0.4em;
  }
}

.quick-info {
  img {
    width: 40px;
  }
  h5 {
    margin-bottom: 0;
  }
  .row {
    min-height: 50px;
  }
}

.row-assessed {
  padding-top: 0px !important;
  margin-left: 0px;
  .col{
    padding-left: 0px;
  }
}

.row-assessed:nth-child(even) {
  background: $grå8;
}
.row-assessed:first-child {
  border-bottom: 2px solid;
}

.detailed-info {
  .row {
    padding-top: 30px;
  }

  p {
    display: inline;
  }
}

.item + .item:before {
  content: ", ";
}
.substance,
.dosage-form {
  margin-top: 8px;
}

.section-name {
  color: $white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888;
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 95px;
  width: 100%;
  background-image: url("../assets/crushing-background.jpg");
  background-position-y: bottom;
  background-size: cover;
}

body .view-container {
  padding-top: 40px;
}

.substance-input {
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1;
}

.substance-search-result {
  position: absolute;
  max-width: 768px;
  right: 0;
  left: 0;
  margin-top: -.3rem;
  padding: 0;
  background-color: #FFFFFF;
  border: .1rem solid #E2E4E7;
  border-radius: 0 0 .3rem .3rem;
  box-shadow: 0 2px 24px 0 rgba(0,0,0,.1), 0 2px 4px 0 rgba(0,0,0,.1), 0 0px 4px 0 rgba(0,0,0,.1);
}

.substance-search-result > ul {
  min-height: 8rem;
  padding: 1rem 0;
  border-top: .1rem solid #E2E4E7;
  list-style-type: none;
}

.substance-search-result__action {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 3.5rem;
  color: #273342;
  text-align: left;
  text-decoration: none;
  background-color: transparent;
  border: none;
  line-height: inherit;

  &:hover {
    background-color: #E2E4E7;
  }
}

.substance-search-result__action--is-selected {
  background-color: #E2E4E7;
}
</style>
